<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cn"><a href="#/SinsofSummer_toc#chap-3"><strong>CHAPTER</strong></a></h1>
<h1 class="cn1"><a href="#/SinsofSummer_toc#chap-3"><strong>* 3 *</strong></a></h1>
<p class="p1">As soon as the door closed behind Ben Waller and her brother, Dory took a deep, painful breath. Louis would enjoy telling
         the man about her sinful past. She dreaded seeing the scorn in Ben’s steel-gray eyes when he came back into the kitchen. Dory
         squeezed her own eyes shut for an instant and relaxed her features before she turned to face her daughter. She knew what to
         expect. Jeanmarie’s little face would be puckered to cry, and somehow Dory had to head off the tears before they started.
         Jeanmarie never cried or made a sound during a scene with Louis or Milo, but it tore her heart to see the fear on her daughter’s
         little face.
      </p>
<p>“We’re lucky.” Dory smiled brightly. “We get to keep Odette with us for a while.” She helped Odette remove her coat again
         and hung it back on the peg.
      </p>
<p>“All night?” Jeanmarie asked in wonderment.</p>
<p>“All night and tomorrow.”</p>
<p>“Oh goody! Oh goody!” The child clapped her hands.</p>
<p>“I think we’ll celebrate and have some of that sugar candy we made the other day.” Dory went to the pantry and returned with
         a plate covered with a cloth, which she whipped off with a flourish.
      </p>
<p>Jeanmarie laughed happily and Dory sighed with relief. She gestured for Odette to sit down, then sat down opposite her.</p>
<p>“Candy,” she said slowly. “Sweet. Hummm…” She licked her lips, and to her delight Odette laughed.</p>
<p>“Candy. Good.”</p>
<p>“You understood me! That’s wonderful.” In her excitement, Dory reached across the table and squeezed Odette’s hand.</p>
<p>“Yes.”</p>
<p>“I’m glad you’re here,” Dory said, still holding onto Odette’s hand.</p>
<p>“Me too,” Odette said, and then with a worried frown looked toward the door where her father had disappeared. “Your man?”</p>
<p>“No.” Dory shook her head. “Brother. Br… oth… er,” she repeated slowly. “Jeanmarie”—she turned to indicate her daughter—“and
         I don’t pay any attention when he yells. Oh, goodness, you didn’t hear him—”
      </p>
<p>“He’s mad at Papa.”</p>
<p>“He’ll get over it. He needs your papa,” she added.</p>
<p>“You got a mama?” Jeanmarie asked with sticky brown juice running from the corner of her mouth.</p>
<p>“Honey, you can’t talk to Odette with your mouth full and you must look right at her and talk slowly.” Dory repeated the question
         for her daughter, glad that she had asked it.
      </p>
<p>Odette watched Dory’s lips and shook her head. “Mama’s dead.”</p>
<p>Dory nodded solemnly. “My mama too,” she said slowly.</p>
<p>“You got a papa?” Odette liked the woman with the short ringlets all over her head. She had never seen a woman with hair so
         short and tried not to stare.
      </p>
<p>Dory shook her head.</p>
<p>“Pretty,” Odette said, touching the top of Jeanmarie’s head.</p>
<p>“Our hair is so curly that it was in a constant tangle, so we cut it. It’s easier to take care of.” Dory laughed down at her
         daughter. “It created quite a stir, didn’t it, honey? We’re the only bobbed-haired women in the territory.”
      </p>
<p>Seeing Odette’s quizzical look, Dory realized she had spoken too fast and repeated her words slowly.</p>
<p>“Pretty,” Odette said again.</p>
<p>“You’re very pretty too.”</p>
<p>“Me?” Odette pointed a finger to her chest, then shook her head and picked up a blond braid that lay on her chest. “Ugh.”
         She made a face.
      </p>
<p>Jeanmarie’s laughter was cut short when the men came into the room. The child’s anxious eyes went from her uncle to her mother.
         Dory couldn’t bring herself to look at Ben, sure that she would see contempt on his face.
      </p>
<p>“Get Mr. Waller some coffee.” Louis issued the order briskly.</p>
<p>“Your brother invited Odette to stay here with you. Before I ask Odette if that’s agreeable to her, I want to know how you
         feel about it.” Ben spoke as soon as she set the coffee in front of him.
      </p>
<p>“Hell, man. She’ll do as she’s told.” Louis poured a cup of coffee for himself and slammed the coffeepot back down on the
         stove.
      </p>
<p>Dory’s lips curled in a sneer and the glance she threw at her brother was one of pure hatred.</p>
<p>“Are you sure you want to leave your daughter in the care of a… strumpet, a loose woman who already has one child out of wedlock?”
         Dory’s face hardened still more as she spat out the words. “Didn’t Louis tell you that I’m a whore and that I practice my
         trade as soon as he leaves the house? Surely he told you. He tells every man who comes within a mile of me.”
      </p>
<p>“Dory, shut up!” Louis yelled.</p>
<p>Jeanmarie whimpered softly and Dory moved to place her hand on her daughter’s shoulder. She reminded Ben of a mother bear
         protecting her cub.
      </p>
<p>“Aren’t you afraid that I’ll lead your daughter astray?” she persisted sarcastically.</p>
<p>“I’m not afraid you’ll have a bad influence on my daughter. Odette will not easily be led astray.”</p>
<p>“How do you know that? I just might teach her the pleasures of the… flesh!”</p>
<p>“My God—” Louis shouted.</p>
<p>Dory’s face was almost as red as her child’s hair; her nostrils quivered and her eyes were bright with anger and humiliation.</p>
<p>“Odette will tell me if you do. And before we leave, I’ll make sure that engine is blown to hell and back.”</p>
<p>Louis pounded his fist on the table and roared, “You goddamn <em>slut!”</em></p>
<p>Both Dory and Ben ignored him. “Jeanmarie and I will be glad to have your daughter here with us, and I’ll do my best to see
         to it that she’s not exposed to any unpleasantness.” Dory spoke softly and only to Ben.
      </p>
<p>“I’ll pay board for my girl. She’ll not be a burden to you.”</p>
<p>“There’s no need for you to pay. It’ll go with the job. Isn’t that right, Louis?”</p>
<p>“I guess so,” he mumbled.</p>
<p>“Odette will do her share of the work if you tell her what to do.”</p>
<p>Ben turned and looked into Odette’s anxious face. “You can’t stay at the logging camp. You’ll either have to stay here while
         I work, or we’ll leave. Miss Callahan has invited you to stay with her and the little girl. We don’t have much choice… at
         the moment.”
      </p>
<p>Odette placed her hand on his arm and looked back at Louis standing beside the cookstove.</p>
<p>“I’ll do what you say, Papa.”</p>
<p>“You’ll be all right here.”</p>
<p>“You won’t go away?”</p>
<p>“Of course not. The camp is only a few miles from here.”</p>
<p>“Lady’s nice. But… him—” She said the words and looked again at Louis.</p>
<p>“Tell her that he’s at the mill most of the time.”</p>
<p>“That’s when you do your sniffin’ around, huh, Dory?” Louis sneered.</p>
<p>Dory wanted the girl to stay so bad she could taste it. To have another woman in the house to talk to would be heavenly. The
         winter had been so long and so… lonely. But she didn’t dare appear too eager or Louis would find a way to keep the girl out
         of the house without losing Waller.
      </p>
<p>“I wouldn’t blame the girl if she didn’t want to stay.” Dory turned toward her brother. “But if you want this man to help
         you best the Malones, you’d better keep your mouth shut.”
      </p>
<p>Odette studied the woman’s face and the face of the little girl. The woman’s clear green eyes had a lonely, pleading look,
         and her little girl was so still as she waited patiently for a question she didn’t understand to be settled.
      </p>
<p>Odette suddenly remembered sitting on the doorstep and listening to the pleading voice of her mother arguing with a man, shivering
         at his harsh replies. She had known that the dispute was about her and had waited anxiously for the outcome. Finally the man
         had walked out, slamming the door without looking back. Then had come the sound of her mother crying. Odette had crept into
         the house, wet a cloth and bathed her mother’s swollen face.
      </p>
<p>She tugged on Ben’s arm so he would look at her. “You need the work?”</p>
<p>“That’s about the size of it, honey.”</p>
<p>“Then I stay.”</p>
<p>Ben put his arm across the girl’s shoulders, pulled her head to his chest, then raised her chin so she could see his face.</p>
<p>He spoke slowly and softly. “Maybe Miss Callahan will teach you to make bread and to sew a dress out of the goods we bought
         in Spokane.”
      </p>
<p>Odette smiled. “You like the bread?”</p>
<p>“Mmmm… very much.” Ben’s hand smoothed the girl’s hair back from her face.</p>
<p>Dory was mesmerized by the tender affection Ben Waller showed his daughter and by how easy it was for him to make her understand
         what he was saying. Tenderness between her mother and father was a treasured memory. She felt a stab of envy. It had been
         so long since anyone other than Jeanmarie had embraced her.
      </p>
<p>“I’ll go up and light a fire in Milo’s room. He can sleep in James’s room or in the bunkhouse when he’s home.” Dory picked
         up Jeanmarie and set her astraddle her hip.
      </p>
<p>“Milo won’t like it,” Louis said in a voice so loud that Jeanmarie hid her face against her mother’s chest.</p>
<p>“That’s too bad,” Dory retorted.</p>
<p>“The girl can sleep with you and… her.” He jerked his head toward the child on her hip. Never had she heard him utter her
         child’s name, and anger forced a bitter response.
      </p>
<p>“She has a name. It’s <em>Jeanmarie!</em> The bunk in my room is not even a full-size bed, as you well know. Odette will sleep in Milo’s room.”
      </p>
<p>“I say she’ll sleep in yours—”</p>
<p>“No, Louis. My bunk is too small.”</p>
<p>“I’m the head of this house, goddammit!” he shouted, his bushy brows drawn together over eyes blazing with anger.</p>
<p>“If you don’t have room for Odette why did you suggest she stay here?”</p>
<p>“Pay no attention to him, Mr. Waller. Odette will have Milo’s bed. If I said it was raining, Louis would say the sun was shining.
         I’m used to his contrariness. He’s always been this way. I realize it’s hard for an outsider to understand the bickering that
         goes on here.” Dory looked straight at Ben, refusing to be cowed by her brother’s bullying.
      </p>
<p>“Hush your mouth! You’re lucky to have a roof over your head considerin’ what you are!”</p>
<p>Dory ignored the insult. “Stay for supper, Mr. Waller. Louis will be here to make sure we’re well chaperoned.”</p>
<p>“Mouthy, know-it-all bitch,” Louis sneered as soon as the kitchen door closed behind Dory. “See what I got to put up with?
         Someday… someday—” He doubled up a fist and struck the palm of his other hand. “I’d like to—” He broke off the words and yanked
         his mackinaw off the hook. “Got some things to see to. Be back in a minute. If that crippled bastard’s been sittin’ around
         on his arse all week and ain’t made them nails, I’ll kick him out even if it is twenty below. Ain’t no use havin’ the best
         iron and best forge in the territory if it ain’t used.” He screwed his wool cap down on his head and slammed out the door.
      </p>
<p>Ben seethed. Was the man thinking he’d go upstairs and jump his sister as soon as he went out the door? Was that why he said
         he’d be back in a minute? Ben wondered if the other brothers were as disagreeable as Louis. If so, he’d pull freight regardless
         of the pay. Odette had not understood what had gone on between Miss Callahan and her brother. Had she heard their words, she
         might have been uneasy about staying here. It was hard for him to believe a man would say the things Louis Callahan had said
         to and about his sister even if they were true. But the woman had admitted she had a child and was not married. Maybe there
         was more to the story than what he’d heard so far.
      </p>
<p>Odette looked tired. Last night she had slept on a pallet on a cold floor. Ben had told the innkeeper that she was his wife,
         afraid he would insist that she sleep in the common room with the women who had come in on the stage. They had bedded down
         in a room with another couple. Ben had rolled her in her blanket and pulled her back up against his chest in an effort to
         keep her warm. Since they had been together he had become very sensitive to her fears.
      </p>
<p>Ben was well acquainted with fear. At nineteen he had been unjustly convicted of killing his uncle and had spent six years
         in prison. While there the warden had discovered that he was extremely handy with machinery, and because he had avoided trouble,
         he had been lent out to work with Tom Caffery. Tom, a master craftsman, was considered to be an expert in the setting up and
         operation of the steam donkey, which was having a profound effect on the economics of logging. The old man had taken a liking
         to Ben and had taught him everything he knew. When Ben had been pardoned by the territorial governor after another man had
         confessed to the crime, he had stayed and worked with Tom until the old man had died.
      </p>
<p>Shortly after he had buried Tom, Ben had received a letter, forwarded from the prison, from a young woman in Seattle begging
         him to come to her. Years earlier, when he had been only eighteen. Ben had stayed in a rooming house in Spokane and had shared
         a bed with her. He remembered her as a decent sort of girl, lonely as he was and more than willing to have his company. He
         had been fond of her, but not fond enough to tie himself to her for life, and she had not been ready to settle down either.
         They had had a mutual parting of the ways.
      </p>
<p>When he had reached Seattle, he had found the woman dying. To his surprise, she had introduced him to a thirteen-year-old
         girl and insisted that she was his daughter. The girl was deaf. Her deafness had been caused, her mother said, by a serious
         illness. The girl could talk but was reluctant to do so. Not certain if the girl was his or not, Ben had felt that he couldn’t
         take the chance that she wasn’t his and had taken her with him after they had buried her mother.
      </p>
<p>Other than the money he’d make, Ben had what he considered another good reason for coming to work for the Callahans now. The
         summer that Odette was conceived, Louis and Milo Callahan also had spent time in the rooming house in Spokane. They would
         not remember him, but he remembered the two of them. They had come to town to see the sights and experience every vice it
         offered. At the boardinghouse table they had spoken freely of the big logging operation as if they were its sole owners.
      </p>
<p>The thought nagged at Ben that one of them might have fathered the girl. During the three years he and Odette had been together,
         she had become an important part of his life, and he fervently hoped that she was truly his flesh and blood. He felt a strong
         urge, however, to know for sure, not that it would make any difference in his feelings for her. He rationalized that it would
         only be fair to the girl if he could prove that she came from good pioneer stock if she were not really his child.
      </p>
<p>Ben looked toward the kitchen door when it opened and watched Dory come back into the room carrying her daughter. The minute
         she put the child on her feet the little girl ran to Odette and climbed into her lap. Odette’s smiling eyes sought Ben’s,
         but his attention was focused on Dory Callahan.
      </p>
<p>“Mr. Waller.” Dory spoke in a low tone with her face averted to prevent Odette from reading her lips. “I’ll do my best to
         look after your daughter while she’s here with me. In spite of what Louis said, my bobbed hair, and my child, I am not a loose
         woman.”
      </p>
<p>“It matters little to me what you are. I’ve no choice but to leave Odette here.”</p>
<p>Dory’s face took on a stubborn look. “It was stupid of me to think you’d believe me. Most men believe Louis.”</p>
<p>“Your past is your business. My concern is for Odette.”</p>
<p>“You sound as if you’ve known a few loose women in your day,” she sneered.</p>
<p>“My share.” Lines appeared at the corners of his gray eyes when he smiled. “Odette and I would be on our way to Malone’s if
         not for the blizzard.” He glanced at Odette. She and Jeanmarie were playing patty-cake.
      </p>
<p>“Louis and Milo have a strong dislike for me and Jeanmarie.” Dory didn’t understand her need to explain to this man. “One
         reason is that I strongly resemble my mother. She was only a little older than Louis was when my father married her. He and
         Milo resented her and did everything they could to make her life miserable. My father loved her dearly. She was a loving,
         happy woman who laughed a lot—the opposite, I’m told, of my father’s first wife. As hard as my mother tried, she was never
         able to make peace with Louis and Milo. They even refused to attend her burial.”
      </p>
<p>“Is your full brother as disagreeable as Louis?”</p>
<p>“No, thank heaven! James is three years older than I am. He is good at everything he does. He’s the best high-climber, chopper,
         cutter, peeler, and river rat in the territory. And he is well liked by the men. James lives to provoke Louis and Milo and
         to outdo them in anything they attempt. He’s the cutting foreman of the Callahan Lumber Company only because Papa put that
         provision in his will.”
      </p>
<p>“Then I’ll be working mostly with him.”</p>
<p>“Don’t count on it. Louis will be pushing every step of the way. He’s got his heart set on outdoing the Malones.”</p>
<p>“I take it there is something personal between the Callahans and the Malones.”</p>
<p>“You take it right. My mother was Chip Malone’s foster sister. She was raised in their home. Some say that he was in love
         with her. And… Chip Malone has red hair.”
      </p>
<p>Ben glanced at the red mop on the little girl’s head, and then back at the mother, but she had turned away and was stoking
         the fire in the cookstove.
      </p>
<p>The hastily-put-together supper of fried pork, sauerkraut, boiled potatoes and dried apple pie was the best food Ben and Odette
         had had in weeks. While they ate, Louis talked constantly about the steam donkey. When he wanted more coffee he banged his
         cup on the table and continued to talk.
      </p>
<p>“By God, I bought the best cable money could buy. Steel cable. Milo wanted me to use manila rope, but I said no siree. When
         it’s wet it stretches and is too hard to handle for hauls of more than two hundred feet. With steel cable I have the pulling
         range of over a thousand feet. Ain’t that right, Waller?”
      </p>
<p>“If the cable doesn’t kink and snap.” Ben had an unexpected urge to douse the man’s enthusiasm.</p>
<p>“I expect you to see that it don’t. I’ll pay you good wages to oversee the building of the flume.”</p>
<p>“I’ll set up the engine and teach your men to run it and that’s all.” Ben helped himself to the bread platter when Dory passed
         it across to him, her eyes shining with amusement and awareness that Louis wanted to argue but didn’t dare.
      </p>
<p>“This coffee is as weak as a man’s pecker after a week in a whorehouse. It don’t have no life a-tall,” Louis said, after taking
         a deep gulp from his freshly filled cup. He stared at his sister with a smirk on his thick lips.
      </p>
<p>Ben watched color come up to flood Dory’s cheeks and felt a deep contempt for the man who so obviously enjoyed tormenting
         his sister. His dislike for Louis was rapidly intensifying into downright loathing, and he wondered if he would be able to
         stomach him long enough to set the machinery and train men to operate it.
      </p>
<p>“Such talk is for the bunkhouse, not in front of womenfolk, Callahan.” Ben spoke quietly.</p>
<p>“Harrumpt! What’er ya gettin’ in a snit for? Ya said the gal can’t hear.”</p>
<p>“Your sister can.” Ben’s voice held a note of irritation that went unnoticed by Louis.</p>
<p>“Like I done told ya, she ain’t no untried woman. Ain’t nothin’ ’bout a man she don’t know. Huh, Dory?”</p>
<p>Dory kept her eyes on her plate.</p>
<p>In the silence that followed, Louis continued to scoop food into his mouth and Ben began to wonder if his decision to stay
         here had been a wise one. He glanced at Odette. She was smiling at Jeanmarie, happily unaware of the conversation and the
         tension. His common sense told him that it was better for his daughter to stay here than to make the long, cold ride to the
         Malones with him not knowing what to expect when he got there.
      </p>
<p>Odette’s mother had been such a woman as Dory Callahan. Perhaps he had helped to set the woman’s feet on the path she had
         taken. He had not been her first, of that he was sure. Before she died she had told him that she had been very protective
         of their child and begged him to see her settled with a good man who would love and cherish her as she herself had wanted
         to be.
      </p>
<p>Ben came to a decision. This was a better place for Odette than in a logging camp, even if they had a cabin to themselves.
         He would work here through the summer. By that time, if things went right, he’d have the money to start his own business.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SinsofSummer_chap-3.vue?8a48d652